import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { PassportCircle } from '../Icons/PassportCircle';
import { PassportLogoProps } from '../interfaces/components';

const PassportLogo = ({ name, logo, fill, stroke, collected }: PassportLogoProps) => {
  return (
    <Box w="80px" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <Image src={logo} alt="laroca" w="60px" h="60px" objectFit="contain" />
      <Text
        fontFamily="SangBleuBPLight"
        fontSize={['10px', '10px', '10px', '11px']}
        width="100%"
        color="#455255"
        textAlign="center"
        mt="3"
      >
        {name}
      </Text>
      <Box display="flex" gap="1" mt="1">
        <PassportCircle fill={collected >= 1 ? fill : '#fff'} stroke={stroke} boxSize={[3]} />
        <PassportCircle fill={collected >= 2 ? fill : '#fff'} stroke={stroke} boxSize={[3]} />
        <PassportCircle fill={collected >= 3 ? fill : '#fff'} stroke={stroke} boxSize={[3]} />
      </Box>
    </Box>
  );
};

export default PassportLogo;
